import React, { useState } from 'react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { Textarea } from './ui/textarea';
import { Mail, Phone, Send } from 'lucide-react';
import { toast } from 'sonner';

const CONTACT_EMAIL = 'contacto@solvere.com.ar';
const CONTACT_PHONE = '342-5376513';

const ContactForm = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
    business: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setIsSubmitting(true);

    const subject = `Consulta desde la web - ${formData.business}`;
    const body = [
      `Nombre: ${formData.name}`,
      `Email: ${formData.email}`,
      `Teléfono: ${formData.phone || '-'}`,
      `Rubro/Empresa: ${formData.business}`,
      '',
      `Consulta:`,
      formData.message,
    ].join('\n');

    const mailtoUrl = `mailto:${CONTACT_EMAIL}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = mailtoUrl;

    toast.success('Consulta enviada', {
      description: 'Te respondemos en breve.',
      duration: 4000,
    });

    setFormData({
      name: '',
      email: '',
      phone: '',
      business: '',
      message: '',
    });

    setIsSubmitting(false);
  };

  return (
    <section id="contact" className="py-24 bg-slate-950 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-[0.95fr,1.05fr] gap-10 items-start">

          {/* 🔥 BLOQUE IZQUIERDO CORREGIDO */}
          <div className="space-y-6">
            <span className="inline-flex px-4 py-2 rounded-full bg-white/10 text-blue-200 text-sm font-semibold border border-white/10">
              Contacto
            </span>

            <h2 className="text-4xl sm:text-5xl font-bold leading-tight">
              Hablemos de tu proyecto
            </h2>

            <p className="text-lg text-slate-300 leading-relaxed max-w-xl">
              Describinos tu necesidad y te presentamos una propuesta clara, adaptada a tu forma de trabajo.
            </p>

            <div className="grid gap-4 pt-4">
              <a
                href={`mailto:${CONTACT_EMAIL}`}
                className="flex items-center gap-4 rounded-2xl border border-white/10 bg-white/5 p-4 hover:bg-white/10 transition-colors"
              >
                <div className="w-12 h-12 rounded-2xl bg-blue-600/20 flex items-center justify-center">
                  <Mail className="h-5 w-5 text-blue-300" />
                </div>
                <div>
                  <p className="text-sm text-slate-400">Email</p>
                  <p className="font-semibold">{CONTACT_EMAIL}</p>
                </div>
              </a>

              <a
                href={`tel:${CONTACT_PHONE.replace(/-/g, '')}`}
                className="flex items-center gap-4 rounded-2xl border border-white/10 bg-white/5 p-4 hover:bg-white/10 transition-colors"
              >
                <div className="w-12 h-12 rounded-2xl bg-blue-600/20 flex items-center justify-center">
                  <Phone className="h-5 w-5 text-blue-300" />
                </div>
                <div>
                  <p className="text-sm text-slate-400">Teléfono</p>
                  <p className="font-semibold">{CONTACT_PHONE}</p>
                </div>
              </a>
            </div>
          </div>

          {/* 🔥 FORMULARIO CORREGIDO */}
          <div className="bg-white text-slate-900 rounded-[2rem] p-6 sm:p-8 shadow-2xl border border-slate-200">
            <form onSubmit={handleSubmit} className="space-y-5">

              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2">
                    Nombre
                  </label>
                  <Input
                    name="name"
                    required
                    value={formData.name}
                    onChange={handleChange}
                    placeholder="Tu nombre"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2">
                    Email
                  </label>
                  <Input
                    name="email"
                    type="email"
                    required
                    value={formData.email}
                    onChange={handleChange}
                    placeholder="mail@empresa.com"
                  />
                </div>
              </div>

              <div className="grid sm:grid-cols-2 gap-4">
                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2">
                    Teléfono
                  </label>
                  <Input
                    name="phone"
                    value={formData.phone}
                    onChange={handleChange}
                    placeholder="342-5376513"
                  />
                </div>

                <div>
                  <label className="block text-sm font-medium text-slate-700 mb-2">
                    Rubro o empresa
                  </label>
                  <Input
                    name="business"
                    required
                    value={formData.business}
                    onChange={handleChange}
                    placeholder="Ej: taller, comercio, institución"
                  />
                </div>
              </div>

              <div>
                <label className="block text-sm font-medium text-slate-700 mb-2">
                  ¿Qué necesitás resolver?
                </label>
                <Textarea
                  name="message"
                  required
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="Contanos brevemente qué problema estás teniendo o qué querés mejorar"
                  rows={6}
                />
              </div>

              <Button
                type="submit"
                disabled={isSubmitting}
                className="w-full bg-blue-600 hover:bg-blue-700 text-white h-12 text-base"
              >
                <Send className="h-5 w-5 mr-2" />
                Solicitar diagnóstico
              </Button>

              <p className="text-sm text-slate-500">
                Respuesta en menos de 24 hs.
              </p>

            </form>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ContactForm;